/**
 * Os nomes das variaveis que o rotulo `neverWarms` lista.
 *
 * ⚠️ **O defeito que isto corrige.** A linha mostrava o slug cru do motor --
 * "sem modelo para as variaveis: peak_period, wave_height" --, um identificador
 * tecnico no meio de uma frase em portugues. A tela ja sabe traduzi-lo: o
 * namespace `environmentalVariableEnum` existe nos tres idiomas e e o mesmo que
 * o meteograma usa para titular seus eixos.
 *
 * 📏 **Por que o fallback nao e detalhe.** Dos 20 slugs que o motor realmente
 * escreveu em `metocean.engine_insight_unreachable` (homolog, 11/09/2026), 13
 * tem rotulo e 7 nao (`lightning_density`, `precip_probability_35km`,
 * `wave_energy_directional_swell_01..03`, `wave_dir_spread_factor_sea_01..02`).
 * Sem `defaultValue`, o i18next devolveria a CHAVE inteira -- a tela leria
 * "environmentalVariableEnum.lightning_density", pior do que o slug cru que ela
 * mostra hoje. Com ele, os 13 melhoram e os 7 ficam como estavam.
 */
export type TranslateFn = (
  key: string,
  options: { defaultValue: string },
) => string;

/** O rotulo de UMA variavel, ou o proprio slug quando nao ha traducao. */
export const resolveVariableLabel = (
  translate: TranslateFn,
  slug: string,
): string => translate(`environmentalVariableEnum.${slug}`, { defaultValue: slug });

/**
 * Os rotulos na ORDEM em que o motor os mandou -- a ordem e dele, e reordenar
 * aqui faria duas telas lendo o mesmo payload discordarem entre si.
 */
export const resolveMissingVariableLabels = (
  translate: TranslateFn,
  slugs: readonly string[],
): string[] => slugs.map((slug) => resolveVariableLabel(translate, slug));
